<template>
  <confirm-action-dialog
    :title="$t('components.template.TemplateDialogPasteUrl.title')"
    :isDialogActive.sync="dialog"
    :supressKeyboardCancel="true"
    :rightDisabled="!valid"
    :rightLabel="$t('components.template.TemplateDialogPasteUrl.btn')"
    @leftClick="dialog = false"
    @rightClick="emitUrl"
  >
    <v-card flat>
      <v-form lazy-validation ref="form" v-model="valid">
        <v-card-text>
          <v-text-field v-model="src" :label="$t('components.template.TemplateDialogPasteUrl.label')" outlined />
        </v-card-text>
      </v-form>
    </v-card>
  </confirm-action-dialog>
</template>

<script lang="ts">
import { requiredRule } from "@/lib/rules/requiredRule";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { Component } from "vue-property-decorator";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";

@Component({
  components: { ConfirmActionDialog }
})
export default class TemplateDialogPasteUrl extends DarkModeHighlightMixin {
  dialog = false;

  src = "";

  valid = false;

  emitUrl() {
    this.$emit("onInput", this.src);
    this.dialog = false;
  }

  initialize() {
    this.src = "";
    this.dialog = true;
  }

  get rules() {
    const rules = [];
    rules.push(requiredRule());
    return rules;
  }
}
</script>
